module.exports = "pegasus_template/assets/theme4/small/4.jpg";